// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-input-container {
  display: flex;
  flex-direction: column;
  border: 1px solid #373D43;
  border-radius: 8px;
  background-color: hsla(212, 21%, 88%, 0.20);
  width: 280px;
}

.custom-input-label {
  display: block;
  position: absolute;
  padding: 5px 0px 0px 7px;
  font-weight: 400;
  font-size: 12px;
  color: #6A696E;
}

.custom-input-wrapper {
  display: flex;
  align-items: center;
  padding: 5px;
  margin-top: 16px;
  position: relative;
  /* min-width: 260px; */
}

.custom-input-field {

  border: none;
  outline: none;
  flex: 1;
  font-weight: 700;
  font-size: 14px;
  color: #6A696E;
  background-color: hsla(212, 21%, 88%, 0);
}

.custom-input-image {
  width: 28px;
  height: auto;
  position: absolute;
  margin-left: 5px;
  right: 26px;
  top: 0px;
}


.large {
  width: 428px;
}


.xlarge {
  width: 100%;
}


.widthFull {
  width: 100% !important;
}

.withOutBorder {
  border-left: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-right: none !important;
  border-radius: 0px;
}

.backgroundWhite {
  background-color: white;
}

.fullHeight {
  height: 100%;
}

.custom-input-container.merchandise-value {
  width: 100%;
  border: 1px solid #E1E9EF;
}

.custom-input-container.error {
  border: 1px solid red !important;
}

.container-input-message {
  position: relative;
  width: 100%;
}

.error-message {
  position: absolute;
  margin: 0px;
  color: red;
  font-size: 12px;
}


.input-select-options {
  position: absolute;
  background: white;
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  z-index: 3;
  overflow-y: scroll;
  text-align: center;
  top: 50px;
  border-radius: 8px;
  align-items: center;
  -ms-overflow-style: none;
  scrollbar-width: none;
  border: 1px solid #E1E9EF;
}


.input-select-options::-webkit-scrollbar { 
  display: none; 
}

.input-select-option {
  min-height: 30px;
  padding: 2px;
  line-height: 30px;
  width: 99%;
  cursor: pointer;
}

.input-select-option.selected{
  color: #373D43;
  height: 20px;
  margin: auto 0px;
  background-color: #EDF4FD;
  font-weight: bold;
}

.container-input-message.long {
  margin-right: 30px;
}

.Weight-container {
  margin-right: 32px;
}

.address-from {
  width: 100%;
  background: none;
  
}

.address-from label.custom-input-label {
  display: none;
}


.address-from .custom-input-wrapper {
  margin: 0px !important;
  padding: 0px;
}


.address-from .custom-input-container.address-from {
  border: none !important;
}

.address-from .error-message {
  display: none;
}

.address-from {
  width: 100%;
  background: none;
  border: none;
}

.address-from input.custom-input-field {
  font-family: Nunito;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
}

.no-results {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/CustonInput/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,QAAQ;AACV;;;AAGA;EACE,YAAY;AACd;;;AAGA;EACE,WAAW;AACb;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;;AAElB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,sBAAsB;EACtB,YAAY;AACd;;;AAGA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".custom-input-container {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #373D43;\n  border-radius: 8px;\n  background-color: hsla(212, 21%, 88%, 0.20);\n  width: 280px;\n}\n\n.custom-input-label {\n  display: block;\n  position: absolute;\n  padding: 5px 0px 0px 7px;\n  font-weight: 400;\n  font-size: 12px;\n  color: #6A696E;\n}\n\n.custom-input-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  margin-top: 16px;\n  position: relative;\n  /* min-width: 260px; */\n}\n\n.custom-input-field {\n\n  border: none;\n  outline: none;\n  flex: 1;\n  font-weight: 700;\n  font-size: 14px;\n  color: #6A696E;\n  background-color: hsla(212, 21%, 88%, 0);\n}\n\n.custom-input-image {\n  width: 28px;\n  height: auto;\n  position: absolute;\n  margin-left: 5px;\n  right: 26px;\n  top: 0px;\n}\n\n\n.large {\n  width: 428px;\n}\n\n\n.xlarge {\n  width: 100%;\n}\n\n\n.widthFull {\n  width: 100% !important;\n}\n\n.withOutBorder {\n  border-left: none !important;\n  border-bottom: none !important;\n  border-top: none !important;\n  border-right: none !important;\n  border-radius: 0px;\n}\n\n.backgroundWhite {\n  background-color: white;\n}\n\n.fullHeight {\n  height: 100%;\n}\n\n.custom-input-container.merchandise-value {\n  width: 100%;\n  border: 1px solid #E1E9EF;\n}\n\n.custom-input-container.error {\n  border: 1px solid red !important;\n}\n\n.container-input-message {\n  position: relative;\n  width: 100%;\n}\n\n.error-message {\n  position: absolute;\n  margin: 0px;\n  color: red;\n  font-size: 12px;\n}\n\n\n.input-select-options {\n  position: absolute;\n  background: white;\n  width: 100%;\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  z-index: 3;\n  overflow-y: scroll;\n  text-align: center;\n  top: 50px;\n  border-radius: 8px;\n  align-items: center;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  border: 1px solid #E1E9EF;\n}\n\n\n.input-select-options::-webkit-scrollbar { \n  display: none; \n}\n\n.input-select-option {\n  min-height: 30px;\n  padding: 2px;\n  line-height: 30px;\n  width: 99%;\n  cursor: pointer;\n}\n\n.input-select-option.selected{\n  color: #373D43;\n  height: 20px;\n  margin: auto 0px;\n  background-color: #EDF4FD;\n  font-weight: bold;\n}\n\n.container-input-message.long {\n  margin-right: 30px;\n}\n\n.Weight-container {\n  margin-right: 32px;\n}\n\n.address-from {\n  width: 100%;\n  background: none;\n  \n}\n\n.address-from label.custom-input-label {\n  display: none;\n}\n\n\n.address-from .custom-input-wrapper {\n  margin: 0px !important;\n  padding: 0px;\n}\n\n\n.address-from .custom-input-container.address-from {\n  border: none !important;\n}\n\n.address-from .error-message {\n  display: none;\n}\n\n.address-from {\n  width: 100%;\n  background: none;\n  border: none;\n}\n\n.address-from input.custom-input-field {\n  font-family: Nunito;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  text-align: left;\n}\n\n.no-results {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
